import './TermsAndConditionsApp.less';
import React from 'react';
import __ from "../../i18n";


export default function TermsAndConditionsApp() {

    return <div className="terms-and-conditions-app">
        <h1>{__('Terms and conditions')}</h1>
    </div>;
}
